"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeBackgroundRemoval = exports.nativeBackgroundRemovalResultSchema = exports.nativeBackgroundRemovalArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Args schema
exports.nativeBackgroundRemovalArgsSchema = zod_1.z.object({
    imageUrl: zod_1.z.string().describe('URL of the image to remove background from'),
    filename: zod_1.z
        .string()
        .describe('Optional custom filename for the processed image (without extension)')
        .nullish(),
    emitMode: common_1.emitModeSchema,
});
// Result schema for the native background removal tool
exports.nativeBackgroundRemovalResultSchema = zod_1.z.object({
    type: zod_1.z.literal('file'),
    fileType: zod_1.z.literal('image'),
    filename: zod_1.z.string(),
    source: zod_1.z.object({
        kind: zod_1.z.union([zod_1.z.literal('raw'), zod_1.z.literal('url')]),
        value: zod_1.z.string(),
    }),
});
// Tool definition
exports.nativeBackgroundRemoval = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeBackgroundRemoval',
    displayName: 'Remove Background',
    displayDescription: 'Removes the background from an image using PhotoRoom API',
    category: 'native',
    color: common_1.BRAND_COLORS.IMAGE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.IMAGE),
    icon: 'image-gen',
    argsSchema: exports.nativeBackgroundRemovalArgsSchema,
}, exports.nativeBackgroundRemovalResultSchema);
